import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { IconButton, Typography } from "@mui/material";
import { toDateOnlyStr } from "../../Locale.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { ServiceStatus__ToString_12C6553D, Tickets_Severity__get_BackgroundColor, Tickets_Severity__get_ColorCode, Tickets_Severity__ToString_12C6553D, ServiceType__ToString_12C6553D } from "../../Shared/Shared.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { Components_Chip_51BC9844 } from "../Chip.js";
import CalendarToday from "@mui/icons-material/CalendarToday";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cancel from "@mui/icons-material/Cancel";
import AccessTime from "@mui/icons-material/AccessTime";
import { Components_ActivityEditButton_Z48ACC4F1 } from "./ActivityEditButton.js";
import Delete from "@mui/icons-material/Delete";

export function Components_ActivityItem_Z3817E89A(components_ActivityItem_Z3817E89AInputProps) {
    let elems_6, elems_3, elems, elems_1, matchValue, elems_2, $keyZ1CF7B434, props_17, elems_4, elems_5;
    const onEdit = components_ActivityItem_Z3817E89AInputProps.onEdit;
    const activity = components_ActivityItem_Z3817E89AInputProps.activity;
    const key = components_ActivityItem_Z3817E89AInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const plannedDate = parse(activity.PlannedDate);
    return createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        columnGap: 30 + "px",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        columnGap: 15 + "px",
        flexGrow: 1,
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", toDateOnlyStr(ctx.DateFnsLocale, plannedDate)]]), MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", defaultArg(map((t) => ServiceType__ToString_12C6553D(t, ctx.Language), activity.Type), "Annet")]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        columnGap: 15 + "px",
    }], (elems_1 = [createElement(Components_Chip_51BC9844, {
        key: "low",
        $key: "low",
        primary: Tickets_Severity__ToString_12C6553D(activity.Severity, ctx.Language),
        enabled: true,
        color: Tickets_Severity__get_ColorCode(activity.Severity),
        backgroundColor: Tickets_Severity__get_BackgroundColor(activity.Severity),
    }), createElement(Components_Chip_51BC9844, {
        key: "high",
        $key: "high",
        primary: ServiceStatus__ToString_12C6553D(activity.Status, ctx.Language),
        enabled: true,
        startIcon: (matchValue = activity.Status, (matchValue.tag === 1) ? ((props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(CalendarToday, props_8);
        }) : ((matchValue.tag === 2) ? ((props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(CheckCircle, props_11);
        }) : ((matchValue.tag === 3) ? ((props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Cancel, props_14);
        }) : ((props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(AccessTime, props_5);
        })))),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        columnGap: 15 + "px",
    }], (elems_2 = [($keyZ1CF7B434 = (`activity-${activity.Id}`), createElement(Components_ActivityEditButton_Z48ACC4F1, {
        key: $keyZ1CF7B434,
        $key: $keyZ1CF7B434,
        service: activity,
        onUpdate: (updated) => {
            onEdit();
        },
    })), MuiHelpers_createElement(IconButton, [["children", (props_17 = {}, react.createElement(Delete, props_17))]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        columnGap: 30 + "px",
    }], (elems_4 = [MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", createElement("b", {
        children: [activity.Customer],
    })]]), MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", createElement("b", {
        children: [activity.MachineName],
    })]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(singleton((elems_5 = [MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", activity.Description]])], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

